export default function getOfferProductionTeamMembersByRole({ offer, role }) {
	return Object.entries(offer?.production?.team || {}).reduce((acc, [userId, user]) => {
		if (user?.roles?.includes(role)) {
			const splitName = user.name?.split(" "); // Fix for offer production team not matching schema currently. No need for the values right now so this fixes the zod validation issue.
			const firstName = splitName?.[0] || "";
			const lastName = splitName?.[1] || "";
			return acc.concat({ id: userId, firstName, lastName, email: "", ...user });
		}
		return acc;
	}, []);
}
